import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import RegisterClosuresListing from "./RegisterClosuresListing"
import FullDetail from "./FullDetail"
import Summary from "./Summary"

const RegisterClosures = ({ match }) => (
    <Switch>
        <Redirect
            exact
            from={`${match.url}/`}
            to={`${match.url}/listing`}
        />
        <Route
            path={`${match.url}/listing`}
            component={RegisterClosuresListing}
        />
        <Route path={`${match.url}/summary/:id`} component={Summary} />
        <Route path={`${match.url}/detail/:id`} component={FullDetail} />
    </Switch>
);

export default RegisterClosures;
